import { render, staticRenderFns } from "./OrganizacionesView.vue?vue&type=template&id=81cdc580&"
import script from "./OrganizacionesView.vue?vue&type=script&lang=ts&"
export * from "./OrganizacionesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports